import { z } from 'zod';

/** The API's storage resource types this client uploads for. */
export type UploadResourceType = 'PCMP_DISBURSEMENT';

export type UploadMimeType = 'image/jpeg' | 'image/png' | 'application/pdf';

/** An S3 presigned POST: send every field, then the file last. */
export const presignedUploadSchema = z.object({
  url: z.string(),
  fields: z.record(z.string(), z.string()),
  key: z.string(),
  expiresAt: z.string(),
});

export type PresignedUpload = z.infer<typeof presignedUploadSchema>;

export interface PresignUploadPayload {
  /** Must be the signed-in user: the API checks the key belongs to the caller. */
  userId: number;
  resourceType: UploadResourceType;
  mimeType: UploadMimeType;
}
